import type { ThemeColorCallback } from '@recruit-robin/robin-theme/web-styles';
import type { default as Candidate } from 'model/Candidate/Candidate';
import type { CandidateHistory } from 'shared/legacy/hooks/useCandidateHistoryQuery.types';
import { Ats } from 'types/ats';

export type HistoryCardProps = {
  candidate: Candidate;
  history: CandidateHistory;
  onReply: () => void;
  atsName?: Ats;
  metadata?: Record<string, any>;
  showUnreadOption: boolean;
};

export type IconSize = 'default' | 'small';

export enum IconSizeEnum {
  DEFAULT = 'default',
  SMALL = 'small',
}

export type HistoryCardVariantProps = {
  title: string;
  icon: React.ReactNode;
  variantColorDiv: ThemeColorCallback;
  variantColorIcon: ThemeColorCallback;
};
